import { render, staticRenderFns } from "./PostingTypeUpdate.vue?vue&type=template&id=25cb75a6"
import script from "./PostingTypeUpdate.vue?vue&type=script&lang=js"
export * from "./PostingTypeUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports